import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';

import { BreadcrumbItem, Breadcrumbs } from 'shared/page/Breadcrumbs';

import { addResultPageFiltersToUrl } from '../lib/utils/queryParamFilterConversions';
import { Filters } from '../interfaces';

interface Props {
    hotelName?: string;
    filters?: Filters;
}

export const PpBreadcrumbs: React.FC<Props> = ({ hotelName, filters }): ReactElement<Props> => {
    const router = useRouter();
    const resultPath = `${router.basePath}/resultat`;
    const items: BreadcrumbItem[] = [
        { url: '/reise/', title: 'Reise' },
        { url: '/reise/pakkereiser/', title: 'Pakkereiser' },
        { url: filters ? addResultPageFiltersToUrl(resultPath, filters) : resultPath, title: 'Resultat' },
        ...(hotelName ? [{ url: '#', title: hotelName }] : []),
    ];

    return <Breadcrumbs items={items} />;
};
